import { Metadata } from '@/types/metadata';

export const DEFAULT_NOT_SELECTED_VALUE = -1;
export const DATE_FORMAT_SHORT_YEAR = 'DD.MM.YY';
export const DATE_FORMAT_SHORT = 'DD.MM.YYYY';
export const FORMAT_DATE_MASK = 'YYYY-MM-DD';
export const MONTH_YEAR_MASK = 'MM.YYYY';
export const DAY_MONTH_MASK = 'DD.MM';
export const MONTHNAME_YEAR_MASK = 'MMMM YYYY';
export const ISO_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const HOURS_MINUTES_FORMAT = 'HH:mm';

export const DEFAULT_META_IMAGE_URL = 'https://fishplace.ru/img/default.webp';

export const DEFAULT_META_DATA: Metadata = {
	title: 'FishPlace: легко покупайте и продавайте рыбу оптом',
	description:
		'FishPlace — международный цифровой оптовый рынок — логистика и торговля по всей России и на экспорт.',
	additionalTags: [],
	imageUrl: DEFAULT_META_IMAGE_URL,
};

export const DEFAULT_EN_META_DATA: Metadata = {
	title: 'FishPlace: buy and sell fish wholesale with ease',
	description:
		'FishPlace is an international digital wholesale marketplace for seafood trade and logistics across Russia and for export.',
	additionalTags: [],
	imageUrl: DEFAULT_META_IMAGE_URL,
};

export const AvoidRedirectList = ['login', 'registration', 'register-storage'];

export const DURATION_DAYS_SUBSCRIBE = 45;

export const EMAIL_REGEXP = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
